document.documentElement.classList.remove('no-js');

const siteHeader = document.querySelector('.site-header');
const announcementBar = document.querySelector('.announcement');
const searchDropdown = document.querySelector('[data-search-dropdown]');
const searchToggle = document.querySelector('[data-search-toggle]');
const searchInput = document.querySelector('[data-search-input]');
const searchResults = document.querySelector('[data-search-results]');
const searchHeading = document.querySelector('[data-search-heading]');
const searchMetaLink = document.querySelector('[data-search-meta-link]');
const searchViewAll = document.querySelector('[data-search-view-all]');
const searchClear = document.querySelector('[data-search-clear]');
const cartDrawer = document.querySelector('[data-cart-drawer]');
const cartDrawerBody = document.querySelector('[data-cart-drawer-body]');
const cartDrawerFooter = document.querySelector('[data-cart-drawer-footer]');
const cartToggle = document.querySelector('[data-cart-toggle]');
const cartCount = document.querySelector('[data-cart-count]');
const cartSubtotal = document.querySelector('[data-cart-subtotal]');
const cartDiscounts = document.querySelector('[data-cart-discounts]');
const productVideoFloat = document.querySelector('[data-product-video-float]');
const productVideoModal = document.querySelector('[data-product-video-modal]');
const collectionSection = document.body.classList.contains('template-collection') ? document.querySelector('.collection-hero') : null;
let quickAddModal = null;
let quickAddContent = null;
const defaultSearchResults = searchResults ? searchResults.innerHTML : '';
let lastScrollY = window.scrollY;
let headerScrollTicking = false;
let searchController = null;
let collectionController = null;
let collectionRequestId = 0;
const collectionFilterMedia = window.matchMedia('(max-width: 640px)');
let filterStickyTicking = false;
let lastFilterScrollY = window.scrollY;
let filterStickyDirection = 'down';

const relocateProductVideoUI = () => {
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  if (mobileDrawer && mobileDrawer.parentElement !== document.body) {
    document.body.appendChild(mobileDrawer);
  }
  if (cartDrawer && cartDrawer.parentElement !== document.body) {
    document.body.appendChild(cartDrawer);
  }
  if (productVideoFloat && productVideoFloat.parentElement !== document.body) {
    document.body.appendChild(productVideoFloat);
  }
  if (productVideoModal && productVideoModal.parentElement !== document.body) {
    document.body.appendChild(productVideoModal);
  }
};

const setProductGalleryImage = (thumb) => {
  const gallery = thumb ? thumb.closest('.product-gallery') : null;
  const mainImage = gallery ? gallery.querySelector('.product-main-image') : null;
  const nextImage = thumb ? thumb.dataset.productImage : '';
  const thumbImage = thumb ? thumb.querySelector('img') : null;
  if (!mainImage || !nextImage) return;

  mainImage.removeAttribute('srcset');
  mainImage.src = nextImage;
  if (thumbImage && thumbImage.alt) mainImage.alt = thumbImage.alt;

  gallery.querySelectorAll('[data-product-thumb]').forEach((button) => {
    button.classList.toggle('is-active', button === thumb);
    button.setAttribute('aria-pressed', button === thumb ? 'true' : 'false');
  });
};

const shopifyRoute = (path) => {
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  return `${root}${path.replace(/^\/+/, '')}`;
};

const cartAddEndpoint = (form) => {
  const action = form.getAttribute('action') || shopifyRoute('cart/add');
  const url = new URL(action, window.location.origin);
  url.pathname = url.pathname.replace(/\/cart\/add\/?$/, '/cart/add.js');
  return `${url.pathname}${url.search}`;
};

const showSiteHeader = () => {
  if (siteHeader) siteHeader.classList.remove('site-header--hidden');
};

const setHeaderHeight = () => {
  if (!siteHeader) return;
  document.documentElement.style.setProperty('--site-header-height', `${siteHeader.offsetHeight}px`);
  document.documentElement.style.setProperty('--announcement-height', `${announcementBar ? announcementBar.offsetHeight : 0}px`);
};

const updateHeaderVisibility = () => {
  if (!siteHeader) return;

  const currentScrollY = window.scrollY;
  const delta = currentScrollY - lastScrollY;
  const drawerOpen = document.body.classList.contains('drawer-open');
  const fixedStart = announcementBar ? announcementBar.offsetHeight : 0;
  const shouldFixHeader = currentScrollY > fixedStart;

  document.body.classList.toggle('header-is-fixed', shouldFixHeader);
  setHeaderHeight();

  if (!shouldFixHeader || drawerOpen || currentScrollY < 80 || delta < -2) {
    siteHeader.classList.remove('site-header--hidden');
  } else if (delta > 3) {
    siteHeader.classList.add('site-header--hidden');
  }

  lastScrollY = currentScrollY;
  headerScrollTicking = false;
};

const setMobileDrawer = (open) => {
  const drawer = document.querySelector('[data-mobile-drawer]');
  const toggle = document.querySelector('[data-mobile-toggle]');
  if (!drawer) return;

  if (open) showSiteHeader();
  drawer.toggleAttribute('open', open);
  drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.body.classList.toggle('drawer-open', open);
  if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
};

const formatMoney = (cents) => {
  const amount = Number(cents || 0) / 100;
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
};

const renderPrice = (variant) => {
  if (!variant) return '';
  const compareAt = Number(variant.compare_at_price || 0);
  const price = Number(variant.price || 0);
  if (compareAt > price) {
    return `<span class="price"><span>${formatMoney(price)}</span><span class="compare">${formatMoney(compareAt)}</span></span>`;
  }
  return `<span class="price"><span>${formatMoney(price)}</span></span>`;
};

const updateCartCount = (count) => {
  if (!cartCount) return;
  cartCount.textContent = count;
  cartCount.hidden = count === 0;
};

const getCartVariantText = (item) => {
  if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
  return (item.options_with_values || [])
    .filter((option) => option.value && option.value !== 'Default Title')
    .map((option) => option.value)
    .join(' / ');
};

const cartOriginalLinePrice = (item) => Number(item.original_line_price || item.line_price || 0);
const cartFinalLinePrice = (item) => Number(item.final_line_price || item.line_price || 0);
const cartOriginalUnitPrice = (item) => {
  const quantity = Number(item.quantity || 1);
  return Number(item.original_price || (quantity ? Math.round(cartOriginalLinePrice(item) / quantity) : item.price) || 0);
};
const cartFinalUnitPrice = (item) => Number(item.final_price || item.price || 0);

const renderCartPrice = (current, original) => {
  if (Number(original || 0) > Number(current || 0)) {
    return `
      <span class="cart-price-pair">
        <s>${formatMoney(original)}</s>
        <span>${formatMoney(current)}</span>
      </span>
    `;
  }
  return formatMoney(current);
};

const getDiscountTitles = (discounts = []) => discounts
  .map((discount) => discount.title || discount.code || discount.application?.title || '')
  .filter(Boolean);

const renderCartLineDiscounts = (item) => {
  const allocations = [
    ...(Array.isArray(item.discounts) ? item.discounts : []),
    ...(Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : []),
  ];
  const titles = [...new Set(getDiscountTitles(allocations))];
  const saved = Math.max(0, cartOriginalLinePrice(item) - cartFinalLinePrice(item));
  if (!titles.length && !saved) return '';
  const label = titles.length ? titles.join(', ') : 'Automatischer Rabatt';
  const saving = saved ? ` -${formatMoney(saved)}` : '';
  return `<span class="cart-drawer-discount">${escapeHtml(label)}${saving}</span>`;
};

const renderCartDiscountSummary = (cart) => {
  if (!cartDiscounts) return;
  const totalDiscount = Number(cart.total_discount || 0);
  if (!totalDiscount) {
    cartDiscounts.hidden = true;
    cartDiscounts.innerHTML = '';
    return;
  }

  const titles = [...new Set(getDiscountTitles(cart.cart_level_discount_applications || []))];
  const label = titles.length ? titles.join(', ') : 'Rabatt';
  cartDiscounts.hidden = false;
  cartDiscounts.innerHTML = `
    <span>${escapeHtml(label)}</span>
    <strong>-${formatMoney(totalDiscount)}</strong>
  `;
};

const renderCartDrawer = (cart) => {
  if (!cart || !cartDrawerBody || !cartDrawerFooter) return;

  updateCartCount(cart.item_count);
  cartDrawerFooter.hidden = cart.item_count === 0;
  if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
  renderCartDiscountSummary(cart);

  if (cart.item_count === 0) {
    cartDrawerBody.innerHTML = `
      <div class="cart-drawer-empty">
        <h3>Dein Warenkorb ist leer</h3>
        <p>Entdecke Kristalle, Schmuckstücke und Sets für dein Zuhause.</p>
      </div>
    `;
    if (cartDiscounts) {
      cartDiscounts.hidden = true;
      cartDiscounts.innerHTML = '';
    }
    return;
  }

  const groups = cart.items.reduce((accumulator, item) => {
    const key = item.product_id || item.product_title;
    if (!accumulator[key]) accumulator[key] = { product: item, items: [], quantity: 0, total: 0, originalTotal: 0 };
    accumulator[key].items.push(item);
    accumulator[key].quantity += item.quantity;
    accumulator[key].total += cartFinalLinePrice(item);
    accumulator[key].originalTotal += cartOriginalLinePrice(item);
    return accumulator;
  }, {});

  cartDrawerBody.innerHTML = Object.values(groups).map((group) => {
    const product = group.product;
    const image = product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.product_title)}" loading="lazy">` : '';
    const variants = group.items.map((item) => {
      const variantText = getCartVariantText(item) || 'Standard';
      return `
          <div class="cart-drawer-variant-row" data-cart-key="${escapeHtml(item.key)}">
          <div class="cart-drawer-variant-meta">
            <strong>${escapeHtml(variantText)}</strong>
            <span>${renderCartPrice(cartFinalUnitPrice(item), cartOriginalUnitPrice(item))}</span>
            ${renderCartLineDiscounts(item)}
          </div>
          <div class="cart-drawer-variant-actions">
            <div class="cart-drawer-qty">
              <button type="button" data-cart-qty="${Math.max(0, item.quantity - 1)}" data-cart-key="${escapeHtml(item.key)}">-</button>
              <input type="number" min="0" value="${item.quantity}" data-cart-qty-input data-cart-key="${escapeHtml(item.key)}">
              <button type="button" data-cart-qty="${item.quantity + 1}" data-cart-key="${escapeHtml(item.key)}">+</button>
            </div>
            <button class="cart-drawer-remove" type="button" data-cart-remove data-cart-key="${escapeHtml(item.key)}">Entfernen</button>
          </div>
        </div>
      `;
    }).join('');

    return `
      <div class="cart-drawer-item cart-drawer-item--grouped">
        <a class="cart-drawer-image" href="${escapeHtml(product.url)}">${image}</a>
        <div class="cart-drawer-copy">
          <a class="cart-drawer-item-title" href="${escapeHtml(product.url)}">${escapeHtml(product.product_title)}</a>
          <div class="cart-drawer-variant">Gesamtmenge ${group.quantity}</div>
          <div class="cart-drawer-price">${renderCartPrice(group.total, group.originalTotal)}</div>
        </div>
        <div class="cart-drawer-variants">
          ${variants}
        </div>
      </div>
    `;
  }).join('');
};

const fetchCart = async () => {
  const response = await fetch(shopifyRoute('cart.js'), { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart request failed');
  return response.json();
};

const changeCartItem = async (key, quantity) => {
  const response = await fetch(shopifyRoute('cart/change.js'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ id: key, quantity })
  });
  if (!response.ok) throw new Error('Cart change failed');
  return response.json();
};

const getProductFormMessage = (form) => {
  let message = form.querySelector('[data-product-form-message]');
  if (message) return message;

  message = document.createElement('div');
  message.className = 'product-form-message';
  message.setAttribute('data-product-form-message', '');
  message.setAttribute('role', 'status');
  message.setAttribute('aria-live', 'polite');
  form.appendChild(message);
  return message;
};

const setProductFormMessage = (form, text, tone = 'error') => {
  const message = getProductFormMessage(form);
  message.textContent = text;
  message.dataset.tone = tone;
  message.hidden = !text;
};

const readCartError = async (response) => {
  if (response.status === 401 || response.status === 403) {
    return `Shopify hat die Warenkorb-Anfrage blockiert (${response.status}). Bitte öffne zuerst die Passwortseite, gib das Storefront-Passwort ein und lade diese Produktseite danach neu.`;
  }

  try {
    const data = await response.json();
    const message = data.description || data.message || data.status;
    return message ? `${message}` : `Shopify konnte den Artikel nicht hinzufügen (${response.status}).`;
  } catch (error) {
    return `Shopify konnte den Artikel nicht hinzufügen (${response.status}).`;
  }
};

const ensureQuickAddModal = () => {
  if (quickAddModal) return quickAddModal;

  quickAddModal = document.createElement('div');
  quickAddModal.className = 'quick-add-modal';
  quickAddModal.setAttribute('data-quick-add-modal', '');
  quickAddModal.setAttribute('aria-hidden', 'true');
  quickAddModal.innerHTML = `
    <button class="quick-add-backdrop" type="button" aria-label="Schnellansicht schliessen" data-quick-add-close></button>
    <div class="quick-add-panel" role="dialog" aria-modal="true" aria-label="Schnellansicht">
      <button class="quick-add-close" type="button" aria-label="Schnellansicht schliessen" data-quick-add-close>&times;</button>
      <div data-quick-add-content></div>
    </div>
  `;
  document.body.appendChild(quickAddModal);
  quickAddContent = quickAddModal.querySelector('[data-quick-add-content]');
  return quickAddModal;
};

const setQuickAddOpen = (open) => {
  ensureQuickAddModal();
  quickAddModal.toggleAttribute('open', open);
  quickAddModal.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.body.classList.toggle('quick-add-open', open);
};

const pauseVideos = (container) => {
  if (!container) return;
  container.querySelectorAll('video').forEach((video) => video.pause());
};

const playMutedVideos = (container) => {
  if (!container) return;
  container.querySelectorAll('video').forEach((video) => {
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
  });
};

const setProductVideoModalOpen = (open) => {
  if (!productVideoModal) return;
  productVideoModal.toggleAttribute('open', open);
  productVideoModal.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.body.classList.toggle('product-video-open', open);

  if (open) {
    pauseVideos(productVideoFloat);
    productVideoModal.querySelectorAll('video').forEach((video) => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    });
  } else {
    pauseVideos(productVideoModal);
    playMutedVideos(productVideoFloat);
  }
};

const productImageSrc = (product) => {
  if (product.featured_image) return product.featured_image;
  if (product.images && product.images.length) return product.images[0];
  return '';
};

const selectedQuickAddVariant = () => {
  if (!quickAddModal) return null;
  const select = quickAddModal.querySelector('[data-quick-add-variant]');
  if (!select || select.tagName !== 'SELECT') return null;
  try {
    return JSON.parse(select.options[select.selectedIndex].dataset.variant || '{}');
  } catch (error) {
    return null;
  }
};

const updateQuickAddVariant = () => {
  const variant = selectedQuickAddVariant();
  if (!variant || !quickAddModal) return;
  const price = quickAddModal.querySelector('[data-quick-add-price]');
  const submit = quickAddModal.querySelector('[type="submit"]');
  if (price) price.innerHTML = renderPrice(variant);
  if (submit) {
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
  }
};

const renderQuickAdd = (product) => {
  ensureQuickAddModal();
  const availableVariants = product.variants || [];
  const firstVariant = availableVariants.find((variant) => variant.available) || availableVariants[0];
  const image = productImageSrc(product);
  const descriptionHtml = product.description || '';
  const descriptionText = descriptionHtml
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const shortDescription = descriptionText.length > 230 ? `${descriptionText.slice(0, 230).trim()}...` : descriptionText;
  const variantOptions = availableVariants.map((variant) => {
    const label = variant.title && variant.title !== 'Default Title' ? variant.title : 'Standard';
    const state = variant.available ? '' : ' - Ausverkauft';
    return `<option value="${variant.id}" data-variant="${escapeHtml(JSON.stringify(variant))}" ${firstVariant && variant.id === firstVariant.id ? 'selected' : ''}>${escapeHtml(label)}${state}</option>`;
  }).join('');
  const hasMultipleVariants = availableVariants.length > 1 || (firstVariant && firstVariant.title !== 'Default Title');

  quickAddContent.innerHTML = `
    <div class="quick-add-layout">
      <div class="quick-add-image">
        ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
      </div>
      <div class="quick-add-content">
        <h3>${escapeHtml(product.title)}</h3>
        ${shortDescription ? `<p class="quick-add-description">${escapeHtml(shortDescription)}</p>` : ''}
        <div data-quick-add-price>${renderPrice(firstVariant)}</div>
        <form class="quick-add-form" action="${shopifyRoute('cart/add')}" method="post" data-quick-add-form>
          ${hasMultipleVariants ? `
            <label class="quick-add-field">
              Variante
              <select name="id" data-quick-add-variant>
                ${variantOptions}
              </select>
            </label>
          ` : `<input type="hidden" name="id" value="${firstVariant ? firstVariant.id : ''}" data-quick-add-variant>`}
          <label class="quick-add-field">
            Menge
            <input type="number" name="quantity" min="1" value="1">
          </label>
          <button class="btn" type="submit" ${firstVariant && firstVariant.available ? '' : 'disabled'}>${firstVariant && firstVariant.available ? 'In den Warenkorb' : 'Ausverkauft'}</button>
        </form>
        <a class="quick-add-view-link" href="${escapeHtml(product.url || `/products/${product.handle}`)}">Produktdetails ansehen</a>
      </div>
    </div>
  `;
  updateQuickAddVariant();
};

const openQuickAdd = async (handle, button) => {
  if (!handle) return;
  ensureQuickAddModal();
  setQuickAddOpen(true);
  quickAddContent.innerHTML = '<div class="quick-add-content"><h3>Wird geladen...</h3></div>';
  if (button) button.disabled = true;

  try {
    const response = await fetch(shopifyRoute(`products/${handle}.js`), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Product request failed');
    renderQuickAdd(await response.json());
  } catch (error) {
    quickAddContent.innerHTML = '<div class="quick-add-content"><h3>Produkt konnte nicht geladen werden.</h3><p class="cart-drawer-note">Bitte oeffne die Produktseite und versuche es erneut.</p></div>';
  } finally {
    if (button) button.disabled = false;
  }
};

const getSelectedOptions = (form) => {
  const selected = [];
  form.querySelectorAll('[data-option-position]').forEach((input) => {
    if (!input.checked) return;
    selected[Number(input.dataset.optionPosition) - 1] = input.value;
  });
  return selected;
};

const updateSelectedVariant = (form) => {
  const variantsScript = form.querySelector('[data-product-variants-json]');
  const idInput = form.querySelector('input[name="id"]');
  if (!variantsScript || !idInput) return null;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent || '[]');
  } catch (error) {
    return null;
  }

  const selectedOptions = getSelectedOptions(form);
  if (!selectedOptions.length) return variants.find((variant) => String(variant.id) === String(idInput.value)) || null;

  const variant = variants.find((candidate) => selectedOptions.every((value, index) => !value || candidate.options[index] === value));
  if (!variant) return null;

  idInput.value = variant.id;
  const price = document.querySelector('[data-product-price]');
  if (price) price.innerHTML = renderPrice(variant);
  const submit = form.querySelector('[type="submit"]');
  const buyNow = form.querySelector('[data-buy-now]');
  const disabled = !variant.available;
  if (submit) {
    submit.disabled = disabled;
    submit.textContent = disabled ? 'Ausverkauft' : 'In den Warenkorb';
  }
  if (buyNow) buyNow.disabled = disabled;
  return variant;
};

const setCartOpen = async (open, refresh = false) => {
  if (!cartDrawer || !cartToggle) return;

  if (open) {
    showSiteHeader();
    setMobileDrawer(false);
    setSearchOpen(false);
    cartDrawer.setAttribute('open', '');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('cart-open');
    if (refresh) {
      try {
        renderCartDrawer(await fetchCart());
      } catch (error) {
        // Keep the existing drawer content if cart refresh fails.
      }
    }
  } else {
    cartDrawer.removeAttribute('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('cart-open');
  }
};

const setSearchOpen = (open) => {
  if (!searchDropdown || !searchToggle) return;

  if (open) {
    showSiteHeader();
    setMobileDrawer(false);
    setCartOpen(false);
    searchDropdown.setAttribute('open', '');
    searchDropdown.setAttribute('aria-hidden', 'false');
    searchToggle.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => {
      if (searchInput) searchInput.focus();
    }, 40);
  } else {
    searchDropdown.removeAttribute('open');
    searchDropdown.setAttribute('aria-hidden', 'true');
    searchToggle.setAttribute('aria-expanded', 'false');
  }
};

const formatSearchPrice = (product) => {
  if (product.price) return product.price;
  if (product.price_min) return product.price_min;
  return '';
};

const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;'
})[character]);

const parseHtml = (html) => new DOMParser().parseFromString(html, 'text/html');

const setFilterPanelCollapsed = (panel, collapsed) => {
  const toggle = panel.querySelector('[data-filter-panel-toggle]');
  panel.dataset.collapsed = collapsed ? 'true' : 'false';
  if (toggle) {
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    toggle.textContent = collapsed ? 'Filter anzeigen' : 'Filter ausblenden';
  }
};

const syncMobileFilterPanels = () => {
  document.querySelectorAll('[data-filter-panel]').forEach((panel) => {
    setFilterPanelCollapsed(panel, collectionFilterMedia.matches);
  });
};

const initCrystalFinder = () => {
  document.querySelectorAll('[data-crystal-finder]').forEach((finder) => {
    const options = Array.from(finder.querySelectorAll('[data-finder-option]'));
    const title = finder.querySelector('[data-finder-result-title]');
    const text = finder.querySelector('[data-finder-result-text]');
    const link = finder.querySelector('[data-finder-result-link]');
    if (!options.length || !title || !text || !link) return;

    const setResult = (option) => {
      options.forEach((candidate) => candidate.classList.toggle('is-active', candidate === option));
      title.textContent = option.dataset.title || '';
      text.textContent = option.dataset.text || '';
      link.href = option.dataset.link || '/collections';
    };

    options.forEach((option) => {
      option.addEventListener('click', () => setResult(option));
    });

    setResult(options[0]);
  });
};

const initScrollReveal = () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('reveal-init');
  const revealTargets = document.querySelectorAll(
    '.shopify-section:not(:first-child):not(#shopify-section-header):not(#shopify-section-announcement-bar), .product-card, .category-tile, .intention-tile, .banner-card, .story-image, .story-copy'
  );

  revealTargets.forEach((target) => target.classList.add('reveal-on-scroll'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  revealTargets.forEach((target) => observer.observe(target));
};

const updateFilterPanelSticky = () => {
  filterStickyTicking = false;
  const currentScrollY = window.scrollY;
  filterStickyDirection = currentScrollY < lastFilterScrollY ? 'up' : 'down';
  lastFilterScrollY = currentScrollY;

  document.querySelectorAll('[data-filter-panel]').forEach((panel) => {
    if (window.matchMedia('(max-width: 980px)').matches) {
      panel.style.removeProperty('--filter-panel-sticky-top');
      return;
    }

    const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
    const gap = 18;
    const panelHeight = panel.offsetHeight;
    const viewportHeight = window.innerHeight;
    const naturalTop = headerHeight + gap;
    const fitTop = viewportHeight - panelHeight - gap;
    const stickyTop = panelHeight + naturalTop + gap <= viewportHeight
      ? naturalTop
      : filterStickyDirection === 'up'
        ? naturalTop
        : fitTop;
    panel.style.setProperty('--filter-panel-sticky-top', `${stickyTop}px`);
  });
};

const scheduleFilterPanelSticky = () => {
  if (filterStickyTicking) return;
  filterStickyTicking = true;
  window.requestAnimationFrame(updateFilterPanelSticky);
};

const syncCollectionState = (currentDoc) => {
  if (!collectionSection || !currentDoc) return;

  const nextSection = currentDoc.querySelector('.collection-hero');
  if (!nextSection) return;

  const preservedOpen = new Map();
  collectionSection.querySelectorAll('details[data-filter-group]').forEach((details) => {
    preservedOpen.set(details.dataset.filterGroup, details.open);
  });

  const currentForm = collectionSection.querySelector('[data-collection-form]');
  const nextForm = nextSection.querySelector('[data-collection-form]');
  if (!currentForm || !nextForm) return;

  currentForm.innerHTML = nextForm.innerHTML;

  collectionSection.querySelectorAll('details[data-filter-group]').forEach((details) => {
    if (!preservedOpen.has(details.dataset.filterGroup)) return;
    details.open = preservedOpen.get(details.dataset.filterGroup);
  });

  syncMobileFilterPanels();
  updateFilterPanelSticky();
};

const loadCollectionUrl = async (url, options = {}) => {
  const { updateHistory = true, scrollToTop = false } = options;
  if (!collectionSection) {
    window.location.assign(url);
    return;
  }

  if (collectionController) collectionController.abort();
  collectionController = new AbortController();
  const requestId = ++collectionRequestId;

  collectionSection.classList.add('is-loading');

  try {
    const response = await fetch(url, {
      signal: collectionController.signal,
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    if (!response.ok) throw new Error('Collection request failed');
    const html = await response.text();
    if (requestId !== collectionRequestId) return;
    const doc = parseHtml(html);
    syncCollectionState(doc);
    if (updateHistory) window.history.pushState({ collectionUrl: url }, '', url);
    if (scrollToTop) {
      const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
      const targetTop = Math.max(collectionSection.getBoundingClientRect().top + window.scrollY - headerHeight - 16, 0);
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    }
  } catch (error) {
    if (error.name !== 'AbortError') window.location.assign(url);
  } finally {
    if (requestId === collectionRequestId) collectionSection.classList.remove('is-loading');
  }
};

const renderSearchResults = (products, emptyText = 'Keine Produkte gefunden.') => {
  if (!searchResults) return;

  if (!products || products.length === 0) {
    searchResults.innerHTML = `<div class="search-empty">${emptyText}</div>`;
    return;
  }

  searchResults.innerHTML = products.slice(0, 6).map((product) => {
    const imageValue = product.image || product.featured_image || '';
    const image = typeof imageValue === 'string' ? imageValue : imageValue.url;
    const title = escapeHtml(product.title);
    const url = product.url || '/search';
    const imageMarkup = image ? `<img src="${escapeHtml(image)}" alt="${title}" loading="lazy">` : '';
    const price = formatSearchPrice(product);
    return `
      <a class="search-result-card" href="${escapeHtml(url)}">
        <span class="search-result-image">${imageMarkup}</span>
        <span class="search-result-copy">
          <span class="search-result-title">${title}</span>
          <span class="search-result-price">${escapeHtml(price)}</span>
        </span>
      </a>
    `;
  }).join('');
};

const setSearchState = (query) => {
  const hasQuery = query.trim().length > 0;
  if (searchHeading) searchHeading.textContent = hasQuery ? 'Suchergebnisse' : 'Empfohlen';
  if (searchMetaLink) searchMetaLink.textContent = hasQuery ? 'Schnelle Vorschläge' : 'Beliebte Produkte';
  if (searchClear) searchClear.hidden = !hasQuery;
  if (searchViewAll) {
    searchViewAll.hidden = !hasQuery;
    searchViewAll.href = hasQuery ? `/search?type=product&q=${encodeURIComponent(query.trim())}` : '/search?type=product';
  }
};

const updateSearchSuggestions = async () => {
  if (!searchInput || !searchResults) return;

  const query = searchInput.value.trim();
  setSearchState(query);
  if (query.length < 2) {
    if (searchController) searchController.abort();
    searchController = null;
    searchResults.innerHTML = defaultSearchResults;
    return;
  }

  if (searchController) searchController.abort();
  const controller = new AbortController();
  searchController = controller;

  try {
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last'
    });
    const response = await fetch(`/search/suggest.json?${params.toString()}`, {
      signal: controller.signal,
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Search request failed');
    const data = await response.json();
    if (!searchInput || searchInput.value.trim() !== query || searchController !== controller) return;
    renderSearchResults(data.resources && data.resources.results ? data.resources.results.products : []);
  } catch (error) {
    if (error.name !== 'AbortError' && searchInput && searchInput.value.trim() === query) {
      renderSearchResults([], 'Suche momentan nicht verfügbar.');
    }
  }
};

setHeaderHeight();
updateHeaderVisibility();
relocateProductVideoUI();
syncMobileFilterPanels();
updateFilterPanelSticky();
initCrystalFinder();
initScrollReveal();

document.addEventListener('click', (event) => {
  const productBack = event.target.closest('[data-product-back]');
  if (productBack) {
    event.preventDefault();
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = shopifyRoute('');
    }
    return;
  }

  const productThumb = event.target.closest('[data-product-thumb]');
  if (productThumb) {
    event.preventDefault();
    setProductGalleryImage(productThumb);
    return;
  }

  const filterPanelToggle = event.target.closest('[data-filter-panel-toggle]');
  if (filterPanelToggle) {
    const panel = filterPanelToggle.closest('[data-filter-panel]');
    if (panel) setFilterPanelCollapsed(panel, panel.dataset.collapsed !== 'true' ? true : false);
    return;
  }

  const collectionLink = event.target.closest('.collection-hero .filter-panel a, .collection-hero .active-filters a, .collection-hero .collection-tools__actions a, .collection-hero .pagination a');
  if (collectionLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
    event.preventDefault();
    loadCollectionUrl(collectionLink.href, { scrollToTop: Boolean(collectionLink.closest('.pagination')) });
    return;
  }

  const quickAddButton = event.target.closest('[data-quick-add]');
  if (quickAddButton) {
    openQuickAdd(quickAddButton.dataset.productHandle, quickAddButton);
    return;
  }

  if (event.target.closest('[data-quick-add-close]')) {
    setQuickAddOpen(false);
    return;
  }

  if (event.target.closest('[data-product-video-close]')) {
    if (productVideoFloat) {
      pauseVideos(productVideoFloat);
      productVideoFloat.hidden = true;
    }
    setProductVideoModalOpen(false);
    return;
  }

  if (event.target.closest('[data-product-video-open]')) {
    setProductVideoModalOpen(true);
    return;
  }

  if (event.target.closest('[data-product-video-modal-close]')) {
    setProductVideoModalOpen(false);
    return;
  }

  const searchButton = event.target.closest('[data-search-toggle]');
  if (searchButton) {
    setSearchOpen(searchDropdown ? !searchDropdown.hasAttribute('open') : true);
    return;
  }

  if (searchDropdown && searchDropdown.hasAttribute('open') && !event.target.closest('[data-search-dropdown]')) {
    setSearchOpen(false);
  }

  const cartButton = event.target.closest('[data-cart-toggle]');
  if (cartButton) {
    setCartOpen(cartDrawer ? !cartDrawer.hasAttribute('open') : true, true);
    return;
  }

  if (event.target.closest('[data-cart-close]')) {
    setCartOpen(false);
  }

  const cartQtyButton = event.target.closest('[data-cart-qty]');
  if (cartQtyButton) {
    const key = cartQtyButton.dataset.cartKey;
    const quantity = Number(cartQtyButton.dataset.cartQty);
    if (key) {
      cartQtyButton.disabled = true;
      changeCartItem(key, quantity).then(renderCartDrawer).catch(() => {
        cartQtyButton.disabled = false;
      });
    }
    return;
  }

  const cartRemoveButton = event.target.closest('[data-cart-remove]');
  if (cartRemoveButton) {
    const key = cartRemoveButton.dataset.cartKey;
    if (key) {
      cartRemoveButton.disabled = true;
      changeCartItem(key, 0).then(renderCartDrawer).catch(() => {
        cartRemoveButton.disabled = false;
      });
    }
    return;
  }

  const buyNowButton = event.target.closest('[data-buy-now]');
  if (buyNowButton) {
    const form = buyNowButton.closest('form');
    const variantInput = form ? form.querySelector('input[name="id"]') : null;
    const quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    const variantId = variantInput ? variantInput.value : '';
    const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
    if (!variantId) return;
    window.location.assign(shopifyRoute(`cart/${encodeURIComponent(variantId)}:${quantity}`));
    return;
  }

  const toggle = event.target.closest('[data-mobile-toggle]');
  if (toggle) {
    const drawer = document.querySelector('[data-mobile-drawer]');
    setMobileDrawer(drawer ? !drawer.hasAttribute('open') : true);
  }

  if (event.target.closest('[data-mobile-close]')) {
    setMobileDrawer(false);
  }

  const mobileNavLink = event.target.closest('[data-mobile-drawer] nav a');
  if (mobileNavLink) {
    setMobileDrawer(false);
  }

  const qtyButton = event.target.closest('[data-qty]');
  if (qtyButton) {
    const input = qtyButton.parentElement.querySelector('input');
    const next = Math.max(1, Number(input.value || 1) + Number(qtyButton.dataset.qty));
    input.value = next;
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    setMobileDrawer(false);
    setSearchOpen(false);
    setCartOpen(false);
    setQuickAddOpen(false);
    setProductVideoModalOpen(false);
  }
});

if (searchInput) searchInput.addEventListener('input', updateSearchSuggestions);

document.addEventListener('change', (event) => {
  const collectionInput = event.target.closest('.collection-hero [data-collection-autosubmit]');
  if (collectionInput) {
    const form = collectionInput.closest('[data-collection-form]');
    if (!form) return;
    const params = new URLSearchParams(new FormData(form));
    const url = `${window.location.pathname}?${params.toString()}`;
    loadCollectionUrl(url);
    return;
  }

  if (event.target.closest('[data-quick-add-variant]')) {
    updateQuickAddVariant();
    return;
  }

  const optionInput = event.target.closest('[data-option-position]');
  if (optionInput) {
    const form = optionInput.closest('[data-product-form]');
    if (form) updateSelectedVariant(form);
    return;
  }

  const cartQtyInput = event.target.closest('[data-cart-qty-input]');
  if (cartQtyInput) {
    const key = cartQtyInput.dataset.cartKey;
    const quantity = Math.max(0, Number(cartQtyInput.value || 0));
    if (key) changeCartItem(key, quantity).then(renderCartDrawer);
  }
});

document.addEventListener('submit', (event) => {
  const collectionForm = event.target.closest('[data-collection-form]');
  if (collectionForm) {
    event.preventDefault();
    const params = new URLSearchParams(new FormData(collectionForm));
    const url = `${window.location.pathname}?${params.toString()}`;
    loadCollectionUrl(url);
    return;
  }

  const productForm = event.target.closest('form[action*="/cart/add"]');
  if (!productForm) return;

  event.preventDefault();
  updateSelectedVariant(productForm);
  const submitButton = productForm.querySelector('[type="submit"]');
  const originalButtonText = submitButton ? submitButton.textContent : '';
  setProductFormMessage(productForm, '');
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Wird hinzugefügt...';
  }

  fetch(cartAddEndpoint(productForm), {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: new FormData(productForm)
  })
    .then(async (response) => {
      if (!response.ok) {
        const message = await readCartError(response);
        throw new Error(message || 'Add to cart failed');
      }
      return fetchCart();
    })
    .then((cart) => {
      if (productForm.closest('[data-quick-add-modal]')) setQuickAddOpen(false);
      renderCartDrawer(cart);
      setCartOpen(true);
    })
    .catch((error) => {
      const fallback = 'Der Artikel konnte nicht hinzugefügt werden. Bitte wähle eine verfügbare Variante oder versuche es erneut.';
      setProductFormMessage(productForm, error.message && error.message !== 'Add to cart failed' ? error.message : fallback);
    })
    .finally(() => {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
    });
});

if (searchClear) {
  searchClear.addEventListener('click', () => {
    if (!searchInput || !searchResults) return;
    if (searchController) searchController.abort();
    searchController = null;
    searchInput.value = '';
    searchResults.innerHTML = defaultSearchResults;
    setSearchState('');
    searchInput.focus();
  });
}

window.addEventListener('scroll', () => {
  if (!headerScrollTicking) {
    window.requestAnimationFrame(updateHeaderVisibility);
    headerScrollTicking = true;
  }
  scheduleFilterPanelSticky();
}, { passive: true });

window.addEventListener('resize', () => {
  setHeaderHeight();
  showSiteHeader();
  updateHeaderVisibility();
  syncMobileFilterPanels();
  updateFilterPanelSticky();
});

window.addEventListener('popstate', () => {
  if (!collectionSection || !document.body.classList.contains('template-collection')) return;
  loadCollectionUrl(window.location.href, { updateHistory: false });
});

window.addEventListener('load', () => {
  setHeaderHeight();
  updateHeaderVisibility();
  updateFilterPanelSticky();
});
